// GLAMI voucher handler
// On landing from GLAMI (?glamivoucher=CODE), this script:
//   1) Looks up the code in window.glamiConfig
//   2) Persists it to localStorage (3-day TTL, mirroring promo_codes.js)
//   3) Activates the discount on the Shopify session via /discount/CODE
// Other scripts (PDP/collection banner swap, popup) read from localStorage via getGlamiVoucher().

(function () {
  var STORAGE_KEY = 'glami_voucher';
  var TTL_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

  function getCodeFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('glamivoucher');
    return raw ? raw.toUpperCase() : null;
  }

  function saveVoucher(code, config) {
    var data = {
      code: code,
      percentage: config.percentage,
      campaignName: config.campaignName,
      expiry: Date.now() + TTL_MS
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  // Activate the discount server-side.
  //
  // 1) /discount/CODE sets the session cookie so the code applies to any
  //    items added later and to checkout.
  // 2) POST /cart/update.js forces cart recalc so existing items pick up
  //    the discount.
  // 3) /cart.js reads the fresh cart state.
  //
  // NOTE: Validation via cart.discount_codes + force-refresh on invalid
  // is commented out below — it was not working reliably (false negatives
  // on empty carts and a visible flash before the reload). Left in place
  // for reference; re-enable only after the edge cases above are handled.
  function activateOnShopify(code) {
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin'
    })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: {} })
        });
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      // .then(function (res) { return res.json(); })
      // .then(function (cart) {
      //   // Validation: invalid codes never show up in cart.discount_codes.
      //   // Disabled — this produced false negatives (empty carts return no
      //   // discount_codes regardless of code validity) and the reload
      //   // caused a jarring flash of GLAMI UI before snapping back. Revisit
      //   // after handling the empty-cart case before re-enabling.
      //   var codes = (cart && cart.discount_codes) || [];
      //   var valid = codes.some(function (entry) {
      //     return entry.code && entry.code.toUpperCase() === code.toUpperCase();
      //   });
      //   if (!valid) {
      //     localStorage.removeItem(STORAGE_KEY);
      //     var url = new URL(window.location.href);
      //     url.searchParams.delete('glamivoucher');
      //     window.location.replace(url.toString());
      //   }
      // })
      .catch(function () {});
  }

  // Public helper — read the active GLAMI voucher (or null if expired/missing).
  window.getGlamiVoucher = function () {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!data || !data.expiry || Date.now() > data.expiry) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  };

  // Gate per-product GLAMI UI on the `custom.glami_promotion_id` metafield —
  // only products marked for the active GLAMI campaign should advertise the
  // discount. The metafield is surfaced as `data-glami-promotion-id` on every
  // hookable element; Liquid renders an empty string when the metafield is
  // missing, so a non-empty attribute is the eligibility signal.
  function hasGlamiPromotion(el) {
    if (!el) return false;
    var id = el.dataset.glamiPromotionId;
    return typeof id === 'string' && id.length > 0;
  }

  // EUR→BGN conversion rate (mirrors snippets/dual-price-display.liquid).
  var EUR_TO_BGN = 1.95583;

  function formatDualPrice(priceCents) {
    // Reuse theme.Shopify.formatMoney for the EUR side so the output honours
    // shop.money_format (comma/period separator, symbol placement) and matches
    // neighbouring non-swapped cards. Fall back to a sensible default if the
    // theme helper or money_format hasn't loaded yet.
    var eurStr;
    if (window.theme && window.theme.Shopify && window.theme.Shopify.formatMoney && window.theme.money_format) {
      eurStr = window.theme.Shopify.formatMoney(priceCents, window.theme.money_format);
    } else {
      eurStr = '€' + (priceCents / 100).toFixed(2);
    }
    // BGN side always uses period + 2 decimals per dual-price-display.liquid.
    var bgn = Math.round(priceCents * EUR_TO_BGN) / 100;
    return eurStr + ' / ' + bgn.toFixed(2) + ' лв.';
  }

  // Rewrite the corner "-X%" / "Save X% +Y%" sale badge rendered by
  // snippets/product-label.liquid to match the active GLAMI percentage.
  // Two branches handled:
  //   1) Label contains `.extra-discount` (product has compare_at_price AND
  //      special_discount_code) — replace only the extra-discount text.
  //   2) Label text is "-X%" (no compare_at_price, special_discount_code only)
  //      — regex-replace every "-N%" occurrence, including marquee repeats.
  function swapProductLabel(label, voucher) {
    var extra = label.querySelector('.extra-discount');
    if (extra) {
      extra.textContent = ' +' + voucher.percentage + '%';
      return;
    }
    label.innerHTML = label.innerHTML.replace(/-\d+%/g, '-' + voucher.percentage + '%');
  }

  // Inject a `-X%` sale label into a product-block that doesn't already
  // show one. Used when GLAMI is active on products that had no
  // compare_at_price discount and no special_discount_code metafield.
  function injectProductLabel(block, voucher) {
    var target = block.querySelector('.product-marquee') || block.querySelector('.image__first');
    if (!target) return;
    var label = document.createElement('span');
    label.className = 'product-label sale';
    label.textContent = '-' + voucher.percentage + '%';
    target.insertBefore(label, target.firstChild);
  }

  // Update the `.special-discount-container` displayed code + discounted price.
  function swapDiscountContainer(container, voucher) {
    var productPrice = parseInt(container.dataset.productPrice, 10);
    if (!productPrice) return;

    var multiplier = (100 - voucher.percentage) / 100;
    var discounted = Math.round(productPrice * multiplier);

    var priceEl = container.querySelector('.special-price__value .dual-price-container');
    if (priceEl) priceEl.textContent = formatDualPrice(discounted);

    var codeEl = container.querySelector('.special-price__code');
    if (codeEl) codeEl.textContent = voucher.code;
  }

  // Page-wide swap of every `.special-discount-container[data-product-price]`
  // regardless of where it lives (collection card or PDP price section).
  function swapAllDiscountContainers(voucher) {
    var containers = document.querySelectorAll('.special-discount-container[data-product-price]');
    containers.forEach(function (container) {
      if (container.dataset.glamiApplied === '1') return;
      if (!hasGlamiPromotion(container)) return;
      swapDiscountContainer(container, voucher);
      container.dataset.glamiApplied = '1';
    });
  }

  // Walk every product card on the page and apply GLAMI visuals:
  //   - Swap the sale label if present, inject one if missing entirely
  // (Discount-container swaps are handled by swapAllDiscountContainers.)
  function swapCollectionCards(voucher) {
    var blocks = document.querySelectorAll('.product-block');
    blocks.forEach(function (block) {
      if (block.dataset.glamiApplied === '1') return;
      if (!hasGlamiPromotion(block)) return;

      // Sold-out takes precedence — don't advertise a discount on an
      // unavailable product.
      if (block.querySelector('.product-label.unavailable')) {
        block.dataset.glamiApplied = '1';
        return;
      }

      // Exclude the early-bird-savings-label — it's a hidden placeholder
      // (`display: none !important`) controlled by the early-bird handler.
      // Without the :not(), querySelector picks the hidden one first, we
      // "swap" it successfully, and the user sees nothing.
      var saleLabel = block.querySelector('.product-label.sale:not(.early-bird-savings-label)');
      if (saleLabel) {
        swapProductLabel(saleLabel, voucher);
      } else {
        // Replace any non-sale label (e.g. "НОВО" / new-in) with the GLAMI
        // -X% badge. The GLAMI discount is commercially stronger than a
        // new-in signal, so it wins when both could apply.
        var otherLabel = block.querySelector('.product-label:not(.early-bird-savings-label)');
        if (otherLabel) otherLabel.remove();
        injectProductLabel(block, voucher);
      }

      block.dataset.glamiApplied = '1';
    });
  }

  // Shared helper — build a `.special-discount-container` element with the
  // GLAMI discounted price + code. The caller passes inline label styles so
  // the result visually matches the Liquid-rendered version for that context
  // (collection cards have inline styles on .special-price__label; PDP
  // relies on `.product-page .special-price__label` CSS).
  function buildDiscountContainer(priceCents, voucher, labelInlineStyles) {
    var multiplier = (100 - voucher.percentage) / 100;
    var discounted = Math.round(priceCents * multiplier);

    var container = document.createElement('div');
    container.className = 'special-discount-container glami-injected';

    var label = document.createElement('div');
    label.className = 'special-price__label';
    if (labelInlineStyles) {
      for (var k in labelInlineStyles) {
        if (Object.prototype.hasOwnProperty.call(labelInlineStyles, k)) {
          label.style[k] = labelInlineStyles[k];
        }
      }
    }

    var priceValue = document.createElement('span');
    priceValue.className = 'special-price__value';
    priceValue.textContent = formatDualPrice(discounted);
    label.appendChild(priceValue);

    label.appendChild(document.createTextNode(' с код '));

    var codeSpan = document.createElement('span');
    codeSpan.className = 'special-price__code';
    codeSpan.style.color = '#ff0000';
    codeSpan.style.fontWeight = 'bold';
    codeSpan.textContent = voucher.code;
    label.appendChild(codeSpan);

    container.appendChild(label);
    return container;
  }

  // Collection cards: inject a GLAMI discount container for blocks that
  // have no `.special-discount-container` (products without the
  // special_discount_code metafield). Mirrors the Liquid structure in
  // snippets/product-block.liquid — inline font/padding on the label.
  function injectCollectionCardDiscountDisplay(voucher) {
    var blocks = document.querySelectorAll('.product-block[data-product-price]');
    blocks.forEach(function (block) {
      if (block.dataset.glamiCardApplied === '1') return;
      if (!hasGlamiPromotion(block)) return;
      if (block.querySelector('.special-discount-container[data-product-price]')) return;
      if (block.querySelector('.special-discount-container.glami-injected')) return;

      var priceEl = block.querySelector('.price');
      if (!priceEl) return;

      var productPrice = parseInt(block.dataset.productPrice, 10);
      if (!productPrice) return;

      var container = buildDiscountContainer(productPrice, voucher, {
        fontSize: '16px',
        padding: '6px'
      });

      priceEl.parentNode.insertBefore(container, priceEl.nextSibling);
      block.dataset.glamiCardApplied = '1';
    });
  }

  // PDP price display: on products that have no `special_discount_code`
  // metafield, the `.special-discount-container` isn't rendered by Liquid.
  // Inject a GLAMI equivalent underneath the price wrapper so users see
  // the discounted price + code next to the regular price.
  function injectPdpDiscountDisplay(voucher) {
    var wrappers = document.querySelectorAll('.product-single__price-wrapper[data-product-price]');
    wrappers.forEach(function (wrapper) {
      var info = wrapper.parentNode;
      if (!info) return;
      if (!hasGlamiPromotion(wrapper)) return;
      // Skip when Liquid already rendered a special-discount-container
      // (the regular swap handles that case).
      if (info.querySelector('.special-discount-container[data-product-price]')) return;
      if (info.querySelector('.special-discount-container.glami-injected')) return;
      if (wrapper.dataset.glamiPdpApplied === '1') return;

      var productPrice = parseInt(wrapper.dataset.productPrice, 10);
      if (!productPrice) return;

      // PDP relies on `.product-page .special-price__label` CSS for sizing —
      // no inline styles needed on the label.
      var container = buildDiscountContainer(productPrice, voucher, null);
      wrapper.parentNode.insertBefore(container, wrapper.nextSibling);

      wrapper.dataset.glamiPdpApplied = '1';
    });
  }

  // PDP banner: the weekly-promotion-banner renders a combined percentage
  // (base_discount + metafield promo). For GLAMI we preserve base_discount
  // and replace the promo portion with voucher.percentage, matching the
  // existing combined-display convention.
  function swapPdpBanner(voucher) {
    var wrappers = document.querySelectorAll('[data-special-discount-banner]');
    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.glamiApplied === '1') return;
      if (!hasGlamiPromotion(wrapper)) return;

      var baseDiscount = parseInt(wrapper.dataset.baseDiscount, 10) || 0;
      var total = baseDiscount + voucher.percentage;

      var discountEl = wrapper.querySelector('.weekly-promotion-banner__discount');
      if (discountEl) {
        discountEl.textContent = '-' + total + '%';
      }

      var codeEl = wrapper.querySelector('.weekly-promotion-banner__code strong');
      if (codeEl) {
        codeEl.textContent = voucher.code;
      }

      wrapper.dataset.glamiApplied = '1';
    });
  }

  // Announcement bar: replaces the theme's default .cc-announcement bars when
  // a voucher is active. Reuses .cc-announcement / .cc-announcement__inner so
  // it inherits the theme's configured bar colour and typography.
  function renderAnnouncement(voucher) {
    if (document.getElementById('glami-announcement-bar')) return;

    var siteControl = document.getElementById('site-control');
    if (!siteControl) return;

    // Hide the theme's default announcement(s) — main announcement,
    // discount_code_text, and promotion — so GLAMI is the only bar shown.
    var existing = siteControl.querySelectorAll('.cc-announcement');
    existing.forEach(function (el) {
      el.style.display = 'none';
    });

    var bar = document.createElement('div');
    bar.id = 'glami-announcement-bar';
    bar.className = 'cc-announcement';

    var inner = document.createElement('div');
    inner.className = 'cc-announcement__inner';
    inner.style.backgroundColor = '#7856FF';
    inner.style.color = '#fff';
    inner.textContent = 'ИЗПОЛЗВАЙ ' + voucher.code + ' ЗА -' + voucher.percentage + '% СЕГА';
    bar.appendChild(inner);

    siteControl.insertBefore(bar, siteControl.firstChild);
  }

  // Add-to-cart forms read `data-special-discount-code` and activate that
  // code before submitting (theme.js + one-click-buy.js). When GLAMI is
  // active, override the attribute so add-to-cart re-activates GLAMI
  // instead of the product's metafield code, which would clobber the
  // session cookie we just set.
  function overrideAddToCartCode(voucher) {
    var forms = document.querySelectorAll('[data-special-discount-code]');
    forms.forEach(function (form) {
      if (form.dataset.glamiApplied === '1') return;
      // Only override on GLAMI-eligible products — otherwise let the product's
      // own special_discount_code keep applying on add-to-cart.
      if (!hasGlamiPromotion(form)) return;
      form.dataset.specialDiscountCode = voucher.code;
      form.dataset.glamiApplied = '1';
    });
  }

  // The theme's infinite-scroll (theme.loadInfiniteScroll) appends new
  // product-blocks to .product-list via jQuery without firing a custom
  // event, so we observe mutations and re-run the swap. swapCollectionCards
  // is idempotent — it skips blocks already marked with data-glami-applied.
  function observeCollectionAdditions(voucher) {
    var list = document.querySelector('.product-list');
    if (!list || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      var hasNewBlocks = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return false;
          return (n.classList && n.classList.contains('product-block')) ||
                 (n.querySelector && n.querySelector('.product-block'));
        });
      });
      if (hasNewBlocks) {
        swapAllDiscountContainers(voucher);
        swapCollectionCards(voucher);
        injectCollectionCardDiscountDisplay(voucher);
      }
    });

    observer.observe(list, { childList: true, subtree: true });
  }

  function applyDisplay() {
    var voucher = window.getGlamiVoucher();
    if (!voucher) return;
    swapAllDiscountContainers(voucher);
    swapCollectionCards(voucher);
    injectCollectionCardDiscountDisplay(voucher);
    swapPdpBanner(voucher);
    injectPdpDiscountDisplay(voucher);
    renderAnnouncement(voucher);
    overrideAddToCartCode(voucher);
    observeCollectionAdditions(voucher);
  }

  // Save first — other consumers (display swap, popup) read from localStorage,
  // so this has to populate before any display/render logic runs.
  var code = getCodeFromUrl();
  if (code) {
    var config = window.glamiConfig && window.glamiConfig[code];
    if (config) {
      saveVoucher(code, config);
      activateOnShopify(code);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDisplay);
  } else {
    applyDisplay();
  }
})();
